const moment = require('moment');
const {fsMomentImport} = require("../utils/utils");

class TimeFrame {
    constructor(
        {
            start = moment().startOf('day'),
            end = moment().endOf('day'),
        } = {}
    ) {
        start = fsMomentImport(start);
        this._start = start && start.isValid() ? start : moment().startOf('day')
        end = fsMomentImport(end);
        this._end = end && end.isValid() ? end : moment().endOf('day')
        this._start = start;
        this._end = end;
    }


    get start() {
        return this._start;
    }

    set start(value) {
        if(this._end.isBefore(value)){
            this._end =value.clone().add(1 ,'day')
        }
        this._start = value;
    }

    get end() {
        return this._end;
    }

    set end(value) {
        if(this._start.isAfter(value)){
            this._start = value.clone().subtract(1 ,'day')
        }
        this._end = value;
    }

    static parseFirestore(fsObj){
        return new TimeFrame(fsObj)
    }

    toFirestore(){
        return {
            start: this._start.toDate(),
            end: this._end.toDate(),
        }
    }
}

module.exports = TimeFrame;